import React from 'react'
import { generateJournalPdf } from '../../utils/journalPdfUtils'

const PdfGenerator = ({ data, t, pdfDataUri, setPdfDataUri, invoice_lang }) => {
  React.useEffect(() => {
    const pdfBase64 = generateJournalPdf(data, t, invoice_lang)
    setPdfDataUri(pdfBase64)
  }, [data, t, setPdfDataUri, invoice_lang])

  return (
    <div>
      {pdfDataUri && (
        <iframe
          src={pdfDataUri}
          title="PDF Preview"
          width="100%"
          height="600px"
          style={{ border: '1px solid #000', marginTop: '20px' }}
        />
      )}
    </div>
  )
}

export default PdfGenerator
